export interface INavigationRoute {
  name: string;
  displayName: string;
  meta: { icon: string };
  roles?: string[];
  children?: INavigationRoute[];
}

export default {
  root: {
    name: "/",
    displayName: "navigationRoutes.home",
  },
  routes: [
    // DASHBOARD
    {
      name: "dashboard",
      displayName: "menu.dashboard",
      meta: {
        icon: "dashboard",
      },
      roles: ["CEO", "CTO", "CGO", "CFO", "COO"],
    },

    // Customer
    {
      name: "customers",
      displayName: "menu.customers",
      meta: {
        icon: "person",
      },
      roles: ["CTO", "CEO"],
    },

    // PARTNERS
    {
      name: "partners",
      displayName: "menu.partners",
      meta: {
        icon: "handshake",
      },
      roles: ["CGO", "PM Sales", "CEO"],
      children: [
        {
          name: "lender-partner",
          displayName: "menu.lender-partner",
          meta: {
            icon: "account_balance",
          },
          roles: ["CGO", "PM Sales", "CEO"],
        },
        {
          name: "channel-partner",
          displayName: "menu.channel-partner",
          meta: {
            icon: "hub",
          },
          roles: ["CGO", "PM Sales", "CEO"],
        },
      ],
    },

    // LOANS
    {
      name: "loans",
      displayName: "menu.loans",
      meta: {
        icon: "currency_rupee",
      },
      roles: ["CEO", "CTO", "CGO"],
      children: [
        {
          name: "loan-request",
          displayName: "menu.loan-request",
          meta: {
            icon: "request_quote",
          },
          roles: ["CEO", "CTO", "CGO"],
        },
        {
          name: "loan-enquiry",
          displayName: "menu.loan-enquiry",
          meta: {
            icon: "help_center",
          },
          roles: ["CEO", "CTO", "CGO"],
        },
        {
          name: "lms",
          displayName: "menu.lms",
          meta: {
            icon: "payments",
          },
          roles: ["CTO", "CFO"],
        },
      ],
    },

    // TICKETS
    {
      name: "tickets",
      displayName: "menu.tickets",
      meta: {
        icon: "support_agent",
      },
      roles: ["COO", "Manger Operations", "Executive", "GRO", "CEO"],
      children: [
        {
          name: "all-tickets",
          displayName: "menu.all-tickets",
          meta: {
            icon: "confirmation_number",
          },
          roles: ["COO", "Manger Operations", "CEO"],
        },
        {
          name: "issue",
          displayName: "menu.issue",
          meta: {
            icon: "report_problem",
          },
          roles: ["COO", "Manger Operations", "Executive", "GRO", "CEO"],
        },
      ],
    },

    // UPDATES
    {
      name: "updates",
      displayName: "menu.updates",
      meta: {
        icon: "campaign",
      },
      roles: ["PM Marketing", "CGO", "CEO", "COO", "Manger Operations"],
      children: [
        {
          name: "offer",
          displayName: "menu.offer",
          meta: {
            icon: "local_offer",
          },
          roles: ["PM Marketing", "CGO", "CEO"],
        },
        {
          name: "blogs",
          displayName: "menu.blogs",
          meta: {
            icon: "article",
          },
          roles: ["PM Marketing", "CGO", "CEO"],
        },
        {
          name: "messages",
          displayName: "menu.messages",
          meta: {
            icon: "mail",
          },
          roles: ["COO", "Manger Operations", "CEO"],
        },
        {
          name: "notification",
          displayName: "menu.notification",
          meta: {
            icon: "notifications",
          },
          roles: ["PM Marketing", "CGO", "CEO"],
        },
      ],
    },

    // WORKDESK
    {
      name: "workdesk",
      displayName: "menu.workdesk",
      meta: {
        icon: "workspaces", // Main workspace/dashboard icon
      },
      roles: ["CEO", "CTO", "CGO", "CFO", "COO", "Manager HR", "CHRO", "PM Sales", "Manger Operations", "Executive", "GRO", "PM Marketing", "Field Sales Executive", "Intern"],
      children: [
        {
          name: "employees",
          displayName: "menu.employees",
          meta: {
            icon: "badge",
          },
          roles: ["Manager HR", "CHRO", "CEO"],
        },
        {
          name: "employee-attendance",
          displayName: "menu.employee-attendance",
          meta: {
            icon: "fact_check", // Attendance tracking
          },
          roles: ["CEO", "CTO", "CGO", "CFO", "COO", "Manager HR", "CHRO", "PM Sales", "Manger Operations", "Executive", "GRO", "PM Marketing", "Field Sales Executive", "Intern"],
        },
        {
          name: "staff-attendance",
          displayName: "menu.staff-attendance",
          meta: {
            icon: "fact_check", // Leave / absence management
          },
          roles: ["CEO", "CTO", "Manager HR"],
        },
        {
          name: "leave-hub",
          displayName: "menu.leave-hub",
          meta: {
            icon: "event_busy", // Leave / absence management
          },
          roles: ["CEO", "CTO", "CGO", "CFO", "COO", "Manager HR", "CHRO", "PM Sales", "Manger Operations", "Executive", "GRO", "PM Marketing", "Field Sales Executive", "Intern"],
        },
        {
          name: "leave-management",
          displayName: "menu.leave-management",
          meta: {
            icon: "event_busy", // Leave / absence management
          },
          roles: ["CEO", "CTO", "Manager HR"],
        },
        {
          name: "payroll",
          displayName: "menu.payroll",
          meta: {
            icon: "payments", // Salary & payroll
          },
          roles: ["CEO", "CTO", "Manager HR"],
        },
        {
          name: "documents",
          displayName: "menu.documents",
          meta: {
            icon: "folder_shared", // Company documents/files
          },
          roles: ["CEO", "CTO", "CGO", "CFO", "COO", "Manager HR", "CHRO", "PM Sales", "Manger Operations", "Executive", "GRO", "PM Marketing", "Field Sales Executive", "Intern"],
        },
      ],
    },
  ] as INavigationRoute[],
};